import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import Login from "./views/pages/Auth/Login/Login";
import Cart from "./views/pages/Cart/Cart";
import Category from "./views/pages/Category";
import Delivery from "./views/pages/Delivery";
import Home from "./views/pages/Home/Home";
import Payment from "./views/pages/Payment/Payment";
import Support from "./views/pages/Support/Support";
// import ChangeStoreLocation from "./views/pages/ChangeStoreLocation";
import ChangeUserChannel from "./views/pages/Profile/ChangeUserChannel";
import Credit from "./views/pages/Profile/Credit/Credit";
import Factors from "./views/pages/Profile/Factors";
import Orders from "./views/pages/Profile/Orders";
import OrdersDetails from "./views/pages/Profile/OrdersDetails";
import Points from "./views/pages/Profile/Points";
import Profile from "./views/pages/Profile/Profile";
import ProfileEdit from "./views/pages/Profile/ProfileEdit";

import Cars from "./views/pages/CarPages/Cars";

// import ReturnConfirm from "./views/pages/ReturnConfirm/ReturnConfirm";
// import ReturnProduct from "./views/pages/Return/ReturnProduct";

import BankCancel from "./views/pages/Bank/BankCancel";
import BankDone from "./views/pages/Bank/BankDone";
import BankError from "./views/pages/Bank/BankError";

import ServiceCenterDetail from "./views/pages/ServiceCenter/Detail";
import ServiceCenterHome from "./views/pages/ServiceCenter/Home";
import Address from "./views/pages/Address/newAddress/Address";
import SendOtp from "./views/pages/Auth/SendOtp/SendOtp";
import Customers from "./views/pages/Customers/Customers";
import Invoices from "./views/pages/Invoices/Invoices";
import MyCards from "./views/pages/MyCards/MyCards";
import OrderDetails from "./views/pages/MyOrders/Details/OrderDetails";
import MyOrders from "./views/pages/MyOrders/MyOrders";
import NotFound from "./views/pages/NotFound";
import Notifications from "./views/pages/Notifications/Notifications";
import PaymentResult from "./views/pages/PaymentResult/PaymentResult";
import NewService from "./views/pages/Services/NewService/NewService";
import SelectService from "./views/pages/Services/SelectService/SelectService";
import { Verification } from "./views/pages/Services/Verification/Verification";
import Staffs from "./views/pages/Staffs/Staffs";
import { TermsAndPolicyPage } from "./views/pages/TermsAndPolicy/TermsAndPolicy";
import Wallet from "./views/pages/Wallet/Wallet";
import Appointments from "./views/pages/Appointments";
import ServicesDetails from "./views/pages/Services/Services/ServicesDetails";
import MainLayout from "./layouts/MainLayout";
import ProductSearch from "./views/pages/ProductSearch/ProductSearch";
import ProductDetails from "./views/pages/ProductDetails/ProductDetails";
import AppointmentDetail from "./views/pages/Appointments/Details/AppointmentDetail";
import Stocks from "./views/pages/Stocks/Stocks";
import Fallback from "./views/components/Fallback/Fallback";
import Employees from "./views/pages/Employees/Employees";
import { LanguageRedirector } from "./views/components/LanguageRedirector/LanguageRedirector";
import I18nWrapper from "./layouts/I18Layout";
import QRCodeReaderPage from "./views/pages/Services/NewService/QRCodeReader/QRCodeReaderPage";
import SuccessQRCodePage from "./views/pages/Services/NewService/QRCodeReader/SuccessQRCodePage";
import Privacy from "./views/pages/Privacy/Privacy";
import DeleteAccount from "./views/pages/DeleteAccount/DeleteAccount";
import FastCheckout from "./views/pages/FastCheckout/FastCheckout";
import ChangeCountry from "./views/pages/Country/ChangeCountry";

export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<LanguageRedirector />} />
      <Route
        path=":lang"
        element={
          <I18nWrapper>
            <MainLayout />
          </I18nWrapper>
        }
        errorElement={<Fallback />}
      >
        {/* Home */}
        <Route element={<Home />} exact index />

        {/*  Payment Result  */}
        <Route path="payment/result" element={<PaymentResult />} />
        <Route path="payment/done/" element={<BankDone />} />
        <Route path="payment/error/" element={<BankError />} />
        <Route path="payment/cancel/" element={<BankCancel />} />

        {/* Profile */}
        <Route path="mycars/" element={<Cars />} />
        <Route path="orders/" element={<Orders />} />
        <Route path="order/:id/" element={<OrdersDetails />} />
        <Route path="profile/edit/" element={<ProfileEdit />} />
        <Route path="p/:id/" element={<Points />} />
        <Route path="credit/" element={<Credit />} />
        <Route path="wallet/" element={<Wallet />} />
        <Route path="factors/" element={<Factors />} />
        <Route path="profile/" element={<Profile />} />

        {/* Pages */}
        {/* <Route path="/store/edit/" element={<ChangeStoreLocation />} /> */}
        <Route path="store/edit/" element={<ChangeUserChannel />} />
        <Route path="country/edit/" element={<ChangeCountry />} />
        <Route path="support/" element={<Support />} />
        <Route path="payment/" element={<Payment />} />
        <Route path="cart/" element={<Cart />} />
        <Route path="fast-checkout/" element={<FastCheckout />} />
        <Route path="delivery/" element={<Delivery />} />
        <Route path="my-cards/" element={<MyCards />} />
        <Route path="invoices/" element={<Invoices />} />
        <Route
          path="services/verification/:id/:phone"
          element={<Verification />}
        />
        <Route path="new-service/" element={<NewService />} />
        <Route path="scan-qr" element={<QRCodeReaderPage />} />
        <Route path="success-qr" element={<SuccessQRCodePage />} />
        <Route path="services/:id" element={<ServicesDetails />} />
        <Route path="select-service/" element={<SelectService />} />
        <Route path="staffs/" element={<Staffs />} />
        <Route path="customers/" element={<Customers />} />
        <Route path="terms-and-policy/" element={<TermsAndPolicyPage />} />

        {/* Return */}
        {/* <Route path="/return/:orderline/" element={<ReturnConfirm />} />
      <Route path="/return/" element={<ReturnProduct />} /> */}

        {/* Product Detail */}
        <Route element={<ProductDetails />} path="product/:id/" />
        {/* Product Search */}
        <Route element={<ProductSearch />} path="search" />

        {/*  Service Center  */}
        <Route
          path="service-center/list/:id/"
          element={<ServiceCenterDetail />}
        />

        <Route path="service-center/" element={<ServiceCenterHome />} />

        {/*  Login  */}
        <Route path="login/:route/" element={<Login />} />
        <Route path="login/" element={<Login />} />
        <Route path="verify-otp/:route" element={<SendOtp />} />

        {/* Category  */}
        <Route element={<Category />} path="category/" />

        {/* Address */}
        <Route path="address/:route/" element={<Address />} />

        {/* Appointment */}
        <Route path="appointment/:id" element={<AppointmentDetail />} />
        <Route path="appointment/" element={<Appointments />} exact />

        {/* Previous Orders */}
        <Route path={"my-orders/"} element={<MyOrders />} />
        <Route path={"my-order/:id"} element={<OrderDetails />} />

        {/* Notifications */}
        <Route path={"notifications"} element={<Notifications />} />

        {/* Stocks */}
        <Route path={"stocks"} element={<Stocks />} />

        {/* Employees */}
        <Route path={"employees"} element={<Employees />} />

        <Route element={<Privacy />} path="privacy" />

        <Route element={<DeleteAccount />} path="deleteaccount" />

        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </Route>
      {/* 404 */}
      <Route element={<NotFound />} path="*" />
    </>
  )
);
